var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLetter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 106,
    viewBox: "0 0 124 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.3125 105.333L57.8333 81.8538L64.1041 75.583L81.3125 92.7913L116.896 57.208L123.167 63.4788L81.3125 105.333ZM58.7083 40.1455L107.417 9.08301H9.99996L58.7083 40.1455ZM58.7083 48.8955L9.41663 17.2497V83.1664H46.75L55.5 91.9164H9.41663C7.08329 91.9164 5.04163 91.0413 3.29163 89.2913C1.54163 87.5413 0.666626 85.4997 0.666626 83.1664V9.08301C0.666626 6.74967 1.54163 4.70801 3.29163 2.95801C5.04163 1.20801 7.08329 0.333008 9.41663 0.333008H108.146C110.479 0.333008 112.521 1.20801 114.271 2.95801C116.021 4.70801 116.896 6.74967 116.896 9.08301V44.6663L108.146 53.4163V17.2497L58.7083 48.8955Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLetter);
export default __webpack_public_path__ + "static/media/letter.f4006b50c1376bca8961de797dcc6ecc.svg";
export { ForwardRef as ReactComponent };